import React from 'react';
import styled from '@emotion/styled';
import LanguageToggle from '../languageToggle/LanguageToggle';

const LanguageToggleWrapper = styled.div`
  margin: 1.5rem 2rem 1.9rem;
`;

const Footer: React.FC<{ languageTogglerEnabled: boolean; track: (eventName: string, payload?: object) => void }> = ({ languageTogglerEnabled, track }) => {
  return (
    <>
      {languageTogglerEnabled && (
        <LanguageToggleWrapper>
          <LanguageToggle track={track} />
        </LanguageToggleWrapper>
      )}
    </>
  );
};

export default Footer;
